import { SORTING_OPTIONS } from '../../../constants/sorting-options';
import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { setSortingPreferences } from './setSortingPreferences';

import type { Store } from '../../../store/list/types';

/**
 * Get SortBy preferences from URL or LocalStorage
 */
export const getSortingPreferences = (store: Store): void => {
  const { setSortBy, setSortInitialOption, setSortInitialReverse } = store.getState();
  const searchParams = new URLSearchParams(window.location.search);
  const urlSort = searchParams.get('sort_by');
  const storageSort = LocalStorage.get('recordingSortingPreferences') as string | null;

  // no preference, we do nothing
  if (!urlSort && !storageSort) {
    setSortBy('-relevance_score');
    return;
  }

  // url has priority over localstorage
  const prefs = getParamsFromString(urlSort) || getParamsFromString(storageSort);
  if (!prefs) {
    setSortBy('-relevance_score');
    return;
  }

  const apiNamesToColumn: Record<string, string> = {
    'first_page_path.raw': 'start_path',
    created: 'created_epoch_time',
  };

  const newSortBy = prefs.sortBy ? prefs.sortBy : '-relevance_score';
  // we apply prefs to model
  // Override sorting to the default (relevance sorting) if there aren't any sorting preferences.
  setSortBy(newSortBy);
  setSortInitialOption(apiNamesToColumn[prefs.sortOption] || prefs.sortOption);
  setSortInitialReverse(prefs.reverse);

  // we set url and localstorage if not already done
  setSortingPreferences(newSortBy);
};

// extract from preferences
function getParamsFromString(sortString: string | null) {
  if (!sortString) {
    return false;
  }

  const sortOption = sortString.substring(sortString.indexOf('-') + 1);
  const reverse = sortString.startsWith('-');

  if (!SORTING_OPTIONS.includes(sortOption)) {
    return false;
  }

  return {
    reverse,
    sortOption,
    sortBy: sortString,
  };
}
